import Modal from "../../../../molecules/Modal"
import WarningIcon from "../../../../../assets/icons/Warning"
import Button from "../../../../atoms/Button"
import styles from "./index.module.scss"
import intl from "react-intl-universal"

export const ModalInformation = ({
  title,
  description,
  onCancel,
  onClose,
  bgBtn,
  type,
  isLoad,
  onSubmit,
  titleIsCancel = intl.get("ciq.no_i_want_back"),
  isSubmit = true,
  submitButtonText,
  submitButtonProps,
}) => {

  const bShowCancelButton = typeof onCancel === "function"
  
  return (
    <Modal isOpen={true}>
      <Modal.Header
        style={{
          justifyContent: "center",
          padding: "0.5rem",
        }}
        onClose={onCancel || onClose}
      >
        <h1 className={styles.titleModal}>{title}</h1>
      </Modal.Header>

      <div className={styles.flexCenter}>
        <WarningIcon />
        <p>{description}</p>
      </div>
      <div className={styles.containerButton}>
        {bShowCancelButton && (
          <Button type="button" variant="outline" onClick={onCancel}>
            {titleIsCancel}
          </Button>
        )}
        {isSubmit && (
          <Button
            style={{ background: bgBtn && bgBtn }}
            type={type === "submit" ? "submit" : "button"}
            isLoading={isLoad}
            onClick={() => {
              if (type !== "submit") onClose()

              if (type === "submit") {
                onSubmit()
              }
            }}
            {...submitButtonProps}
          >
            {submitButtonText || intl.get("ciq.yes_continue")}
          </Button>
        )}
      </div>
    </Modal>
  )
}
